<template>

  <nav class="nav">
 
        <div class="col-sm-4">
                <router-link to="/"><img src="/static/logo.png"></router-link>
        </div>
        <div class="col-sm-8">
   <div class="container">   
 <div class=" col-sm-4"> 
    
  <h1  v-if="false" class="nav__subtitle">          
      <router-link class="post__author"
          :to="'/gallery'"><span>Galerie</span></router-link>
    </h1>
    <div class=" col-sm-4" >
  <h1  v-if="false" >/</h1>  

  </div>
  <h1  v-if="false" class="nav__subtitle">          
      <router-link class="post__author"
          :to="'/contact'">Activités</router-link>
    </h1>
</div>

<div class=" col-sm-4" >
  <h1  v-if="show()" class="nav__subtitle">          
      <router-link class="post__author"
          :to="'/contact'">Contact</router-link>
    </h1>
</div>
</div>
 </div>
      
  
    <transition-group tag="menu" name="nav__item" class="nav__menu">
      <li v-for="label in labels" class="nav__item" :key="label" @click="navBack">
        <i class="nav__item--icon"></i>
        <span class="nav__item--label">{{ label }}</span>
      </li>
    </transition-group>
  </nav>
</template>

<script>
export default {
  name: 'blog-nav',
  props: {
    navs: Number,
    content: Object,
    filters: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    labels() {
      return Object.keys(this.filters)
        .map(filter => this.content.labels[filter])
    }
  },

  methods: {
    show() {
      window.rr = this.$router
      return this.$router.currentRoute.path === '/'
    },
    navBack() {
      if (this.navs && !this.filters.author) this.$router.go(-1)
      else this.$router.push('/')
    },
    navContact() {
      this.$router.push('/contact')
    }
  }
}
</script>
<style>
.nav__subtitle {
    line-height: 1;
    font-size: 1 em;
    letter-spacing: -.005em;
}

.nav__subtitle {
    font-family: Prompt, Helvetica, Arial, sans-serif;
    font-weight: 400;
}

</style>


// WEBPACK FOOTER //
// src/components/BlogNav.vue